import { render, staticRenderFns } from "./vipSetting.vue?vue&type=template&id=66088587&scoped=true"
import script from "./vipSetting.vue?vue&type=script&lang=js"
export * from "./vipSetting.vue?vue&type=script&lang=js"
import style0 from "./vipSetting.vue?vue&type=style&index=0&id=66088587&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66088587",
  null
  
)

export default component.exports